/**
 * Service for security grouping create operations
 */

import { apiClient } from '@/api/core';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import { mapCreatedSecurityGroupingToModel } from '../mappers';
import type {
  LC_CreateSecurityGroupingIn,
  LC_CreateSecurityGroupingOut,
  SecurityGrouping,
} from '../types';


export class SecurityGroupingCreateService {
  async create(
    payload: LC_CreateSecurityGroupingIn,
  ): Promise<ApiResponse<SecurityGrouping>> {
    const response = await apiClient.post<LC_CreateSecurityGroupingOut>(
      API_CONFIG.ENDPOINTS.SECURITY_GROUPING.CREATE,
      payload,
    );

    if (response.success && response.data) {
      return {
        ...response,
        data: mapCreatedSecurityGroupingToModel(response.data),
      };
    }

    return { ...response, data: null };
  }
}

export const securityGroupingCreateService = new SecurityGroupingCreateService();
